import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { InstanceProvider } from '../context/instance/instanceContext';
import { WebSocketProvider } from '../context/webSocket/webSocketContext';
import { StoreProvider } from '../redux/storeProvider';
/**
 * Provides all contexts required for most app needs.
 */
export const ContextProviderWrapper = ({ instanceId, numInstances, children }) => {
    return (_jsx(InstanceProvider, { instanceId: instanceId, numInstances: numInstances, children: _jsx(StoreProvider, { children: _jsx(WebSocketProvider, { children: children }) }) }));
};
